var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgListFilm = function SvgListFilm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    enableBackground: "new 0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    fill: "#000",
    fillRule: "nonzero",
    d: "M13.6 0H2.4C1.12 0 0 1.04 0 2.4v11.2C0 14.96 1.04 16 2.4 16h11.2c1.36 0 2.4-1.04 2.4-2.4V2.4C16 1.04 14.96 0 13.6 0zm-.8 5.2h1.6v2h-1.6v-2zm-1.6 2H4.8V1.6h6.4v5.6zm-8 0H1.6v-2h1.6v2zM1.6 8.8h1.6v2H1.6v-2zm3.2 0h6.4v5.6H4.8V8.8zm8 0h1.6v2h-1.6v-2zm1.6-6.4v1.2h-1.6v-2h.8c.48 0 .8.32.8.8zm-12-.8h.8v2H1.6V2.4c0-.48.4-.8.8-.8zm-.8 12v-1.2h1.6v2h-.8c-.4 0-.8-.32-.8-.8zm12 .8h-.8v-2h1.6v1.2c0 .48-.32.8-.8.8z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListFilm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list-film.0ac05473.svg";
export { ForwardRef as ReactComponent };